import {Component, OnInit, inject} from "@angular/core";
import {select, Store} from "@ngrx/store";
import * as AuthActions from "../store/auth.actions";
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {Router} from "@angular/router";
import {animate, state, style, transition, trigger} from "@angular/animations";
import {CommonModule} from "@angular/common";
import {Observable} from 'rxjs';

// PrimeNG Imports
import {CardModule} from 'primeng/card';
import {InputTextModule} from 'primeng/inputtext';
import {PasswordModule} from 'primeng/password';
import {ButtonModule} from 'primeng/button';
import {Button} from 'primeng/button';
import {ToastModule} from 'primeng/toast';
import {MessageService} from 'primeng/api';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import {AuthState} from '../store/auth.state';
import {InputGroup} from "primeng/inputgroup";
import {InputGroupAddon} from "primeng/inputgroupaddon";
import {FloatLabel} from "primeng/floatlabel";
import {Divider} from "primeng/divider";
import {AuthService} from '../../shared/services/auth.service';
import {ThemeService} from '../../shared/services/theme.service';
import {Tooltip} from 'primeng/tooltip';

@Component({
  selector: 'login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
  animations: [
    trigger('fadeInOut', [
      state('void', style({
        opacity: 0
      })),
      transition('void <=> *', animate('0.3s ease-in-out')),
    ]),
  ],
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    CardModule,
    InputTextModule,
    PasswordModule,
    ButtonModule,
    Button,
    ToastModule,
    ProgressSpinnerModule,
    FormsModule,
    InputGroup,
    InputGroupAddon,
    FloatLabel,
    // Divider,
    Tooltip
  ],
  providers: [MessageService, AuthService]
})
export class LoginComponent implements OnInit {
  private themeService = inject(ThemeService);

  loginForm: FormGroup;
  isLoading$: Observable<boolean>;
  error$: Observable<string | null>;
  passwordVisible: boolean = false;

  // Expose theme service signal for template
  isDarkMode = this.themeService.isDarkMode;

  constructor(
    private store: Store<{ auth: AuthState }>,
    private fb: FormBuilder,
    private router: Router,
    private messageService: MessageService,
  ) {
    this.loginForm = this.fb.group({
      username: ['', [
        Validators.required,
      ]],
      password: ['', [
        Validators.required,
      ]],
      rememberMe: [false]
    });

    // Select loading and error states from the store
    this.isLoading$ = this.store.pipe(select(state => state.auth.loading));
    this.error$ = this.store.pipe(select(state => state.auth.error));
  }

  ngOnInit() {
    // Subscribe to error changes to show toast messages
    // removed because it is handled by the auth.effects.ts file
    // this.error$.subscribe(error => {
    //   if (error) {
    //     this.messageService.add({
    //       severity: 'error',
    //       summary: 'Login Failed',
    //       detail: error
    //     });
    //   }
    // });
  }

  submit() {
    if (this.loginForm.valid) {
      this.store.dispatch(AuthActions.login(this.loginForm.value));
    } else {
      Object.keys(this.loginForm.controls).forEach(key => {
        const control = this.loginForm.get(key);
        if (control?.invalid) {
          control.markAsTouched();
        }
      });
    }
  }

  forgotPassword() {
    this.router.navigate(['/forgot-password']);
  }

  loginWithSso() {
    // todo
    console.info('Login with SSO');
  }

  toggleDarkMode() {
    this.themeService.toggleDarkMode();
  }
}
